module.exports = __webpack_public_path__ + "img/app-bdmh.32f43c14.png";